import { Badge } from '@shopify/polaris'

import { getTranslation } from '../util/getTranslation'
import { useAuth } from './AuthContext'

export function ActivationStatusBadge() {
  const { account } = useAuth()
  switch (account.activationStatus) {
    case 'new':
      return <Badge status="attention">{getTranslation('activation.inactive')}</Badge>
    case 'verified':
      return <Badge status="info">{getTranslation('activation.verified')}</Badge>
    default:
      return null
  }
}
